var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"max-width":"750px"}},[_c('v-card-title',{staticClass:"pl-6 pt-4 font-weight-light"},[_vm._v(" 12 Months Total ($) ")]),_c('apexchart',{attrs:{"type":"bar","height":"200px","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }